"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = exports.TitleWrapper = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _utils = require("../../pages/utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

var _Accessibility = require("@insided/destination/modules/Accessibility");

var eventTracker = function eventTracker(_, title, url, type) {
  if (!['parent category', 'category'].includes(type)) {
    return;
  }

  _publish.default.trackEvent('userevent', {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    category_type: type,
    click_source: 'breadcrumb'
  });
};

var TitleWrapper = function TitleWrapper(_ref) {
  var url = _ref.url,
      title = _ref.title,
      type = _ref.type,
      children = _ref.children;

  if (url) {
    return (0, _preact.h)("a", {
      className: "breadcrumb-item-link",
      href: (0, _absoluteUrlRuntime.resolveUrl)(url),
      onClick: function onClick(e) {
        return eventTracker(e, title, url, type);
      }
    }, children);
  } else {
    return (0, _preact.h)("span", {
      className: "current"
    }, children);
  }
};

exports.TitleWrapper = TitleWrapper;
var types = ['homepage', 'parent category', 'category'];
var qaClasses = ['qa-breadcrumb-community', 'qa-breadcrumb-category', 'qa-breadcrumb-forum', 'qa-breadcrumb-topic'];

function isWithPhrase(p) {
  return 'phrase' in p;
}

var widgetName = 'breadcrumb';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-breadcrumb';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.undefined();

exports.config = config;

var Breadcrumb = function Breadcrumb(_ref2) {
  var breadcrumbData = _ref2.breadcrumbData;
  return (0, _preact.h)(_utils.CurrentPageContext.Consumer, null, function (pageContext) {
    var breadcrumbs = breadcrumbData !== null && breadcrumbData !== void 0 ? breadcrumbData : pageContext.breadcrumbs;
    if (!(breadcrumbs !== null && breadcrumbs !== void 0 && breadcrumbs.length)) return (0, _preact.h)("div", {
      id: _Accessibility.DEFAULT_BREADCRUMBS_TARGET_ID
    });
    return (0, _preact.h)("div", {
      id: _Accessibility.DEFAULT_BREADCRUMBS_TARGET_ID,
      className: "sitewidth breadcrumb-container"
    }, (0, _preact.h)("div", {
      className: (0, _classnames.default)('col', 'main-navigation--breadcrumb-wrapper', 'widget--breadcrumb')
    }, (0, _preact.h)("ul", {
      className: "breadcrumb"
    }, breadcrumbs.map(function (data, index) {
      return (0, _preact.h)("li", {
        key: index,
        className: "breadcrumb-item ".concat(qaClasses[index])
      }, isWithPhrase(data) ? (0, _preact.h)(_phrase.default, {
        m: data.phrase[0],
        p: data.phrase[1],
        renderAsText: true
      }, function (title) {
        return (0, _preact.h)(TitleWrapper, {
          url: breadcrumbs.length > index + 1 ? data.url : null,
          title: title,
          type: types[index]
        }, (0, _preact.h)("i", {
          className: (0, _classnames.default)('icon', 'icon--caret-left', 'is-visible-S')
        }), title);
      }) : (0, _preact.h)(TitleWrapper, {
        url: breadcrumbs.length > index + 1 ? data.url : null,
        title: data.title,
        type: types[index]
      }, (0, _preact.h)("i", {
        className: (0, _classnames.default)('icon', 'icon--caret-left', 'is-visible-S')
      }), data.title), (0, _preact.h)("i", {
        className: "icon icon--caret-right"
      }));
    }))));
  });
};

var _default = Breadcrumb;
exports.default = _default;